module.exports = __webpack_public_path__ + "static/media/bottom.37f3459b.png";